import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from '../../../Api/Types/tagTypes';

import { OfferOption } from '../Types/offerOptionsTypes';

export const offerOptionsApi = createGenericApiSlice<OfferOption>({
  reducerPath: 'offerOptionsApi',
  tag: TagTypes.OfferOptions,
  endpoint: 'offer-options',
});

export const {
	useGetAllQuery: useGetOfferOptionsQuery,
	useGetByIdQuery: useGetOfferOptionByIdQuery,
	useCreateMutation: useCreateOfferOptionMutation,
	useUpdateMutation: useUpdateOfferOptionMutation,
	useDeleteMutation: useDeleteOfferOptionMutation,
} = offerOptionsApi;
